import React, { useEffect } from "react"

const useDesktopScrollSync = (
  isMobile: boolean,
  scrollRef: React.MutableRefObject<HTMLDivElement | null>,
  current: number,
  setCurrent: (index: number) => void,
  stepCount: number,
  isManual: boolean
) => {
  useEffect(() => {
    if (isMobile) return

    const handleScroll = () => {
      const container = scrollRef.current
      if (!container) return

      const rect = container.getBoundingClientRect()
      const viewportHeight = window.innerHeight

      const totalScrollable = container.offsetHeight - viewportHeight
      if (totalScrollable <= 0) {
        if (!isManual && current !== 0) setCurrent(0)
        return
      }

      const rawScrolled = Math.min(Math.max(-rect.top, 0), totalScrollable)

      const LAST_STEP_RESERVE = 200
      const effectiveScrollable = Math.max(totalScrollable - LAST_STEP_RESERVE, totalScrollable * 0.7)

      const scrolled = Math.min(rawScrolled, effectiveScrollable)

      const progress = scrolled / effectiveScrollable
      const rawIndex = progress * (stepCount - 1)
      const newIndex = Math.round(rawIndex)

      if (!isManual && newIndex !== current) {
        setCurrent(newIndex)
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    handleScroll() // сразу синхронизируем

    return () => window.removeEventListener("scroll", handleScroll)
  }, [isMobile, current, stepCount, isManual, scrollRef, setCurrent])
}

export default useDesktopScrollSync
